import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "../Styles/LegalDocs.css";

function LegalDocs() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="legal-container">
      {/* Site Title */}
      <header className="legal-header">
        <h1 className="legal-siteTitle">
          <Link to="/">
            AidNix <span className="legal-siteSign"></span>
          </Link>
        </h1>
      </header>

      {/* Main Legal Content */}
      <div className="legal-content">
        <section className="legal-section">
          <h2>Interpretation and Definitions</h2>
          <h3>Interpretation</h3>
          <p>
            The words of which the initial letter is capitalized have meanings
            defined under the following conditions. The following definitions
            shall have the same meaning regardless of whether they appear in
            singular or in plural.
          </p>

          <h3>Definitions</h3>
          <p><strong>Affiliate:</strong> An entity that controls, is controlled by, or is under common control with a party.</p>
          <p><strong>Country:</strong> Rajasthan, India</p>
          <p><strong>Company:</strong> AidNix Solution LLP, Jaipur, Rajasthan.</p>
          <p><strong>Device:</strong> Any device that can access the Service such as a computer, a cellphone, or a digital tablet.</p>
          <p><strong>Service:</strong> Refers to the Website.</p>
          <p><strong>Terms and Conditions:</strong> These Terms govern the use of the Service.</p>

          <h2>Acknowledgment</h2>
          <p>
            These Terms and Conditions set out the rights and obligations of all
            users regarding the use of the Service. Your access and use of the
            Service are conditioned on your acceptance of these Terms.
          </p>
          <p>
            By accessing or using the Service, You agree to be bound by these
            Terms and Conditions. If You disagree with any part, You may not
            access the Service.
          </p>

          <h2>Privacy Policy</h2>
          <p>
            Your privacy is paramount to us. Our Privacy Policy outlines how we
            collect, use, and protect your personal and medical information. We
            ensure secure data handling, and you can trust that your information
            is treated with the utmost confidentiality.
          </p>

          <h2>Consultations</h2>
          <p>
            Our platform connects you with expert doctors who provide online
            consultations. These consultations are not a replacement for
            in-person medical visits but serve as a convenient option for
            medical advice, prescriptions, and guidance.
          </p>

          {/* <h2>How It Works</h2>
          <p>
            Health Plus is designed to simplify healthcare access. You can
            choose a specialist, schedule an appointment, and engage in a
            virtual consultation.
          </p> */}
        </section>

        <section className="legal-section">
          <h2>Legal Notices</h2>
          <p><strong>Governing Law:</strong> The laws of the Country govern these Terms.</p>
          <p><strong>Disputes Resolution:</strong> If you have any concern or dispute about the Service, contact the Company first.</p>
          <p><strong>Links to Other Websites:</strong> The Company is not responsible for third-party web sites.</p>
        </section>

        <section className="legal-section">
          <h2>Changes to Terms</h2>
          <p>
            We reserve the right to modify or replace these Terms at any time.
            If a revision is material, we will make reasonable efforts to
            provide at least 30 days' notice before new terms take effect.
          </p>
        </section>

        <section className="legal-section">
          <h2>Contact Us</h2>
          <p>If you have any questions about these Terms, you can contact us:</p>
          <p><strong>Email:</strong> help@AidNix.com</p>
          <p><strong>Phone:</strong> 7738684066</p>
        </section>
      </div>

      {/* Footer */}
      <footer className="legal-footer">
        <p>© 2025 AidNix. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default LegalDocs;